import marketCapData from "../../../assets/marketCap";

export const retrieveMarketCapData = (symbol) => {
  if (!marketCapData[symbol]) return null;
  return marketCapData[symbol].market_cap;
};
